import { TaskNouns, taskNouns } from "@sp-crm/core";
import { useFeature } from "store/selectors/hooks";

export const useTaskNouns = (): TaskNouns =>
    taskNouns(useFeature("detailsPageVNext") ? "todo" : "task");
